import { ReactNode } from 'react';
import Well from './Well';
import { BoxProps, Theme, Typography } from '@mui/material';
import { IconElement } from '@watershed/icons/Icon';
import { mixinSx } from '@watershed/style/styleUtils';

function BlankSlate({
  variant = 'text',
  size = 'medium',
  direction = 'column',
  icon: Icon,
  iconColor,
  title,
  subtitle,
  ...props
}: Omit<BoxProps, 'title'> & {
  variant?: 'text' | 'contained';
  size?: 'small' | 'medium';
  direction?: 'column' | 'row';
  icon?: IconElement;
  iconColor?: string | ((theme: Theme) => string);
  title: ReactNode;
  subtitle?: ReactNode;
}) {
  const space = size === 'small' ? 1 : 3;
  return (
    <Well
      {...props}
      sx={mixinSx(
        {
          backgroundColor: (theme) =>
            variant === 'contained'
              ? theme.palette.secondary.light
              : 'transparent',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: direction,
          textAlign: 'center',
          padding: space,
        },
        props.sx
      )}
    >
      {Icon && (
        <Icon
          size={size === 'small' ? 32 : 64}
          color={iconColor ?? 'secondary.main'}
          marginBottom={direction === 'column' ? space : undefined}
          marginRight={direction === 'row' ? space : undefined}
        />
      )}
      {subtitle ? (
        <>
          <Typography variant="h2" color="textSecondary" gutterBottom>
            {title}
          </Typography>
          <Typography variant="body2">{subtitle}</Typography>
        </>
      ) : (
        <Typography variant="body2">{title}</Typography>
      )}
      {props.children}
    </Well>
  );
}

export default BlankSlate;
